import { Component, ViewChild, ChangeDetectorRef } from "@angular/core";
import { ListWindow, PageService, TabComponent } from "@xo/client-common";
import { Type4FractionTable } from "./type4Fraction.table";

@Component({
  selector: "spec-app-type4-fraction-list-window",
  templateUrl: "./type4Fraction.list.html",
  styleUrls: ["./type4Fraction.list.scss"]
})
export class Type4FractionListWindowComponent extends ListWindow {

  @ViewChild("table", { static: false }) table: Type4FractionTable;

  clickHandler: Function;

  constructor(changeDetectorRef: ChangeDetectorRef, private tab: TabComponent, public pageService: PageService) {
    super(changeDetectorRef);
  }

  init(filters?) {
    this.clickHandler = this.pageService.createOpenObject(
      "SpecApp/Type4FractionPage",
      this.tab.system,
      (object) => `Type4Fraction at ID:${object ? object.id : null}`,
      () => ({})
    );
    super.init(filters, this.table);
  }

  reload() {
    console.log("Type4FractionList reload");
    super.reload();
    this.table.refreshList();
  }
}
